module.exports = "img/flags/NF.f036025.png";